import React from 'react';
import FieldValidation from '../Fragments/FieldValidation';
import MyHomelet from '../Fragments/MHL';
import FieldError from '../Fragments/FieldError';
import HelpIcon from './HelpIcon';
import HelpText from './HelpText';

let Quote = require('../Managers/Quote');
let Validation = require('../Managers/Validation.js');
let HttpService = require('../Managers/HttpService');

const Config = HttpService.getConfigForHost();
const EmailInput = React.createClass({
    propTypes: {
        fieldName:  React.PropTypes.string.isRequired,
        helpText:   React.PropTypes.string,
        question:   React.PropTypes.string.isRequired,
        loadCachedValue: React.PropTypes.bool.isRequired,
        forceRerender: React.PropTypes.func
    },

    getInitialState() {
        return {
            isValid: (Quote.getCurrentAnswer(this.props.fieldName) || localStorage.getItem("email_address")!="") ? true : false,
            hasError: false,
            errors: null,
            isHelpVisible: false,
            activeValue: (this.props.loadCachedValue) ? Quote.getCurrentAnswer(this.props.fieldName)  : false,
            email : null,
        };
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },

    doValidation() {
        let validation = Validation.validate(this.props.fieldName, $('#email_address').val())[0];
        this.setState(validation);
        if (validation.isValid) {
            Quote.set(this.props.fieldName, $('#email_address').val());
            localStorage.setItem("email_address",$('#email_address').val());
        } else {
            Quote.set(this.props.fieldName, "");
        }
        if (!Quote.hasAnswers(this.props.fieldName)) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        return true;
    },

    lookupUserEmail : function(email) {
        let isLookupValid = false;
        $.ajax({
            type: 'POST',
            async : false,
            data: {
                email
            },
            url: Config.mhl.lookupCustomer.url
        }).done(function(results, textStatus, xhr) {
            if (xhr.status == 200) {
                isLookupValid = true;
            }
        });

        return isLookupValid;
    },

    clearEmail() {
        window.$('#email_address').val('');
        window.removeLocalStorageAnswer('email_address');
        window.removeLocalStorageAnswer('myhomelet_email');
    },

    getEmail() {
        return this.refs.email.value;
    },

    onBlur(event) {
       
        let validation = Validation.validate(this.props.fieldName, event.target.value)[0];

        // we dont need to look you up if you've already
        // been looked up for the email address entered
        let myHomeletEmail = Quote.getCurrentAnswer('myhomelet_email');
        if (event.target.value != myHomeletEmail) {
            if (this.lookupUserEmail(event.target.value)) {
                // this.refs.MyHomelet.setEmail(event.target.value);
                this.refs.MyHomelet.showLogin();
            }
        }

        this.setState(validation);
        if (validation.isValid) {
            Quote.set(this.props.fieldName, event.target.value);
        } else {
            Quote.set(this.props.fieldName, "");
        }
    },

    render() {
        return (
            <div>
                <question-row>
                    <div className="question-main">
                        <div className="question-top">
                            <label>{this.props.question}</label>
                            {this.props.helpText ?  <HelpIcon onClick={this.toggleHelpText} /> : null }
                        </div>
                        <div className="question-input">
                            <input
                                name={this.props.fieldName}
                                id={this.props.fieldName}
                                type="email"
                                className="form-control"
                                onBlur={this.onBlur}
                                defaultValue={this.state.activeValue ?this.state.activeValue :localStorage.getItem("email_address")}
                                //defaultValue={this.state.activeValue}
                                ref="email"
                            />
                            {this.props.helpText ? <HelpText text={this.props.helpText} active={this.state.isHelpVisible} /> : null }
                            {this.state.hasError ? <FieldError errors={this.state.errors} /> : null}

                            {this.props.fieldName == 'email_address' ?
                                <MyHomelet
                                    ref="MyHomelet"
                                    clearEmail={this.clearEmail}
                                    getEmail={this.getEmail}
                                    forceRerender={this.props.forceRerender}
                                />
                                : null}
                        </div>
                    </div>
                    <div className="question-extra">
                        <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                    </div>
                </question-row>
            </div>
        );
    }
});

export default EmailInput;



/** WEBPACK FOOTER **
 ** ./src/components/Fields/EmailInput.js
 **/